import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import * as FileSaver from 'file-saver';
import { ChangePasswordComponent } from 'src/app/home/componenets/auth/change-password/change-password.component';
declare let $: any;
@Component({
  selector: 'app-layout-page',
  templateUrl: './layout-page.component.html',
  styleUrls: ['./layout-page.component.css'],
})
export class LayoutPageComponent implements OnInit {
  searchForm: FormGroup;
  isShowing = false;
  isShowing1 = false;
  isUser = false;
  show = 'over';
  isMenu = false;
  roleValue;
  isMenuOpen = false;
  private getApi = environment.url + environment.profileGet;
  private getcorporateApi = environment.url + environment.initiativecorpGet;
  private listApi = environment.url + environment.incubatorApprovalList;
  private excelDownload = environment.url + environment.incubateeDownload;
  private downloadScroeApi = environment.url + environment.downloadScore;
  private publishScore = environment.url + environment.publishScore;
  currentUrl: string;
  /**
   * This is the constructor of the LayoutPageComponent class.
   * It injects the dependencies required by the component.
   * @param changeDetectorRef The ChangeDetectorRef is used to detect changes in the component.
   * @param media The MediaQueryList is used to detect the screen size.
   * @param router The Router is used to navigate to other pages.
   * @param fb The FormBuilder is used to create the form controls.
   * @param makeapi The ApiService is used to make API calls.
   * @param notify The NotifyService is used to show notifications.
   * @param getdata The ValueService is used to get the values from the API.
   * @param dialog The MatDialog is used to show the dialog for viewing the reasons.
   */
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private notify: NotifyService,
    private getdata: ValueService,
    public dialog: MatDialog
  ) {
    /**
     * This is the mobile query that is used to detect the screen size.
     */
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    /**
     * This is the listener for the mobile query.
     * It is used to detect changes in the screen size.
     */
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    /**
     * This is the form group for the page.
     * It contains the form controls for each question.
     */
    this.searchForm = this.fb.group({
      incubateeName: ['', [Validators.required]],
    });
    /**
     * This is the event subscription for the router.
     * It is used to detect the URL changes.
     */
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
  }
  user: any = [];
  userName: any;
  proReg: any;
  roleName: string;
  contactUs = false;
  applicationId;
  showSideBar: any;
  /**
   * Lifecycle hook that is called after Angular has initialized the component.
   * It sets the component properties and subscribes to the isVisibleSource observable.
   */
  ngOnInit(): void {
    sessionStorage.setItem('urlVal', this.router.url);
    this.currentUrl = this.router.url;
    this.currentUrl = sessionStorage.getItem('urlVal');
    this.applicationId = sessionStorage.getItem('applicationId');
    this.showSideBar = sessionStorage.getItem('show');
    //  if(this.show == 'true'){
    //   window.location.reload();
    // }
    this.viewInitiative();
    //
    // this.route.queryParams.pipe(filter(params => params._title))
    // .subscribe(params => {
    //   this.viewInitiative2(params._title)
    // })
    $('nav .navbar-collapse ul li').click(function () {
      $('.navbar-collapse').removeClass('show');
    });
    this.roleValue = sessionStorage.getItem('role');

    this.getdata.isVisibleSource.subscribe((isVisible) => {
      this.roleValue = sessionStorage.getItem('role');
      document.getElementsByTagName('mat-sidenav-content')[0].scrollTo(0, 0);
      var val = this.router.url;
      this.userName = sessionStorage.getItem('username');
      this.proReg = sessionStorage.getItem('profileReg');
      // this.croReg = sessionStorage.getItem('profileRegCorporate')
      // profileRegCorporate
      this.roleName = sessionStorage.getItem('role');
      var data = val.split('/');
      if (data[1] == 'admin' || data[1] == 'incubator-list') {
        this.contactUs = true;
      } else {
        this.contactUs = false;
      }
      if (this.mobileQuery.matches == false && data[1] == 'admin' && data[2] != 'tnimm2-page') {
        this.isMenu = false;
        this.isUser = true;
        this.isShowing = true;
      } else if (this.mobileQuery.matches == true && (data[1] == 'admin' && (data[2] == 'dashboard' || data[2] == 'pre-incubation' || data[2] == 'coe'))) {
        this.isShowing = false;
        this.isMenu = true;
        this.isUser = true;
      } else {
        this.isMenu = false;
        this.isUser = false;
        this.isShowing = false;
      }

      if (this.userName != null && this.roleName != 'Admin') {
        if (sessionStorage.getItem('logo') != null) {
          this.image_url = sessionStorage.getItem('logo');
        } else {
          this.profileGet();
        }
      } else {
        this.image_url = './assets/images/user.png';
      }
      if (
        data[2] == 'event' ||
        data[2] == 'csr' ||
        data[2] == 'gallery' ||
        data[2] == 'news-letters' ||
        data[2] == 'blog' ||
        data[2] == 'incubatee' ||
        data[2] == 'approval' ||
        data[2] == 'startup' ||
        data[2] == 'corinitiatives'
      ) {
        this.isShowing = false;
      }
      this.mobileQuery.addListener(this._mobileQueryListener);
      if (
        (data[1] == 'admin' && this.roleName == 'Admin') ||
        (data[1] == 'incubator-list' && this.roleName == 'Admin')
      ) {
        this.approvalCount();
      }
      var spl = data[1];
      var da = spl.split('?');
      if (da[0] == 'search') {
        this.searchForm.reset();
        this.showSearch = false;
      } else {
        this.searchForm.reset();
        this.showSearch = true;
      }
    });
  }

  /**
   * Redirects the user to the StartupTN website.
   * Called when the user clicks on the "StartupTN" logo in the navigation bar.
   */
  logoweb() {
    // Open the StartupTN website in a new tab
    window.open('https://startuptn.in/', '_blank');
  }
  showSearch = true;
  /**
   * Redirects the user to the incubator's dashboard page.
   * Called when the user clicks on the "TNIMM" link in the navigation bar.
   */
  incubatorLog() {
    // Show the loading indicator
    this.isShowing = false;

    // Redirect the user to the incubator's dashboard page
    this.router.navigate([
      'admin',
      'tnimm2-page'
    ]);
  }
  pendingCount: string;
  /**
   * Fetches the count of pending approval requests from the API.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API
   */
  approvalCount() {
    this.pendingCount = '';

    // Construct the API request parameters
    const params = `${this.listApi}?listSize=${10}&pageNumber=${1}&status=${0}`;

    // Call the API to fetch the list of pending approval requests
    return this.makeapi.method(params, '', 'get').subscribe((data) => {
      // Check if there are any pending approval requests
      if (data.count != 0) {
        // Update the component data with the count of pending approval requests
        this.pendingCount = data.count.toString();
      }
    });
  }

  /**
   * Searches for an incubatee by name if the name is not empty.
   * Retrieves search form values, and if the incubatee name is provided,
   * it triggers a search operation and hides the search UI.
   */
  incubateeSearch() {
    // Get the form values from the search form
    let getform = this.searchForm.value;

    // Check if the incubatee name is not empty
    if (getform.incubateeName.length > 0) {
      // Trigger the search operation with the provided incubatee name
      this.getdata.searchValue(getform.incubateeName);

      // Hide the search UI
      this.showSearch = false;
    }
  }

  image_url: any = './assets/images/user.png';
  /**
   * Fetches the profile data from the server using a GET request.
   * Updates the `image_url` variable with the received profile image URL.
   * If the profile image does not exist, sets `image_url` to the default user image.
   * Fetches the `showSideBar` value from session storage and stores it in the component's property.
   */
  profileGet() {
    this.image_url = '';
    const username = sessionStorage.getItem('username');
    this.makeapi
      .method(this.getApi + '?username=' + username, '', 'get')
      .subscribe((data) => {
        if (data.incubatorLogoFileName != null) {
          // Set the profile image URL to the received value
          this.image_url = data.incubatorLogoFileName;
          // Set the showSideBar value from session storage
          this.showSideBar = sessionStorage.getItem('show');
          // Store the profile image URL in session storage
          sessionStorage.setItem('logo', data.incubatorLogoFileName);
        } else {
          // Set the profile image URL to the default user image
          this.image_url = './assets/images/user.png';
          // Set the showSideBar value from session storage
          this.showSideBar = sessionStorage.getItem('show');
        }
      });
  }
  element: any[] = [];
  /**
   * Fetches initiative data from the server using a POST request.
   * Updates the element array with the received data.
   */
  viewInitiative() {
    // Make API call to fetch initiative data
    this.makeapi
      .method(this.getcorporateApi, '', 'postunauth')
      .subscribe((data) => {
        // Update the element array with the response data
        this.element = data;
      });
  }
  /**
   * Close the navigation bar when registration button is clicked
   * and navigate to the registration page.
   */
  registerBtn() {
    // Close the navigation bar
    $('.navbar-collapse').removeClass('show');
    // Navigate to the registration page
    this.router.navigate(['register', {}]);
  }
  /**
   * Close the navigation bar when login button is clicked
   * and navigate to the login page.
   */
  loginBtn() {
    // Close the navigation bar
    $('.navbar-collapse').removeClass('show');
    // Navigate to the login page
    this.router.navigate(['login', {}]);
  }
  mobileQuery: MediaQueryList;
  fillerNav = Array.from({ length: 50 }, (_, i) => `Nav Item ${i + 1}`);
  private _mobileQueryListener: () => void;
  ngAfterViewInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  /**
   * Toggle the visibility of the navigation bar based on the mobile query match.
   */
  checkToggle() {
    // Check if the screen size matches the mobile query
    if (this.mobileQuery.matches == true) {
      // Toggle the visibility of the navigation bar
      this.isShowing = !this.isShowing;
    }
  }
  /**
   * Navigate to the profile page and hide the navigation bar.
   */
  profilePage() {
    // Navigate to the profile page
    this.router.navigateByUrl('profile');
    // Hide the navigation bar
    $('.navbar-collapse').removeClass('show');
  }
  /**
   * Navigate to the corporate profile page and hide the navigation bar.
   */
  corprateprofilePage() {
    // Navigate to the corporate profile page
    this.router.navigateByUrl('corporate-profile');
    // Hide the navigation bar
    $('.navbar-collapse').removeClass('show');
  }
  /**
   * Navigate to the event page and hide the navigation bar.
   */
  eventPage() {
    // Navigate to the event page
    this.router.navigateByUrl('/admin/event');
    // Hide the navigation bar
    $('.navbar-collapse').removeClass('show');
  }
  /**
   * Navigate to the gallery page and hide the navigation bar.
   */
  galleryPage() {
    // Navigate to the gallery page
    this.router.navigateByUrl('/admin/gallery');
    // Hide the navigation bar
    $('.navbar-collapse').removeClass('show');
  }
  /**
   * Navigate to the newsletter page and hide the navigation bar.
   */
  newsletterPage() {
    // Navigate to the newsletter page
    this.router.navigateByUrl('/admin/news-letters');
    // Hide the navigation bar
    $('.navbar-collapse').removeClass('show');
  }
  /**
   * Navigate to the incubatee page and hide the navigation bar.
   */
  incubateePage() {
    // Navigate to the incubatee page
    this.router.navigateByUrl('/admin/incubatee');
    // Hide the navigation bar
    $('.navbar-collapse').removeClass('show');
  }
  /**
   * Open the change password dialog.
   * @param value - The title to show in the dialog.
   */
  changepassword(value: string) {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      data: { title: value },
    });
    // Close the dialog after it has finished.
    dialogRef.afterClosed().subscribe((result) => { });
  }

  /**
   * Navigate to the incubator approval page.
   */
  incubatorApproval() {
    // Navigate to the incubator approval page
    this.router.navigateByUrl('/admin/approval');
    // Hide the navigation bar
    $('.navbar-collapse').removeClass('show');
  }
  /**
   * Navigate to the blog list page.
   */
  blogPage() {
    // Navigate to the blog list page
    this.router.navigateByUrl('/admin/blog');
    // Hide the navigation bar
    $('.navbar-collapse').removeClass('show');
  }
  /**
   * Navigate to the startup list page.
   */
  startupPage() {
    // Navigate to the startup list page
    this.router.navigateByUrl('/admin/startup');
    // Hide the navigation bar
    $('.navbar-collapse').removeClass('show');
  }
  /**
   * Logout the user and clear the session storage.
   * If the user is currently in the home page, show the source visibility.
   * If the user is currently in any other page, navigate to the login page.
   */
  logoutBtn() {
    // Get the current URL
    let val = this.router.url;
    // Split the URL into an array
    let data = val.split('/');
    // Clear the session storage
    sessionStorage.clear();

    // If the user is currently in the home page, show the source visibility
    if (data[1] == 'home') {
      // Show the source visibility
      this.getdata.isVisibleSource.next(true);
    } else {
      // Navigate to the login page
      this.router.navigateByUrl('login');
      // Hide the sidebar
      this.isShowing = false;
    }

    // Remove the show class from the navbar collapse
    $('.navbar-collapse').removeClass('show');
  }

  /**
   * Downloads the incubatees data in an Excel file.
   */
  downloadExcel() {
    // Show the loader
    this.getdata.amizhthLoader('show');
    // Call the API to download the incubatees data
    this.makeapi
      .method(
        // The API endpoint to download the incubatees data
        this.excelDownload + sessionStorage.getItem('userId'),
        '',
        'download'
      )
      .subscribe((data) => {
        // Hide the loader
        this.getdata.amizhthLoader('hide');
        // Create the filename for the Excel file
        const date = new Date();
        let currentDate = `${date.getFullYear()}-${date.getMonth() + 1
          }-${date.getDate()}-${date.getSeconds()}`;
        let filename = 'StartupTN_Incubatees_' + currentDate + '.xlsx';
        // Save the Excel file
        FileSaver.saveAs(data, filename);
      });
  }
  /**
   * Downloads the scoring data of the incubatees.
   */
  dowloadScore() {
    // Show the loader
    this.getdata.amizhthLoader('show');
    // Call the API to download the scoring data
    this.makeapi
      .method(this.downloadScroeApi, '', 'download')
      .subscribe((data) => {
        // Hide the loader
        this.getdata.amizhthLoader('hide');
        // Get the current date
        const date = new Date();
        let currentDate = `${date.getFullYear()}-${date.getMonth() + 1
          }-${date.getDate()}-${date.getSeconds()}`;
        // Set the filename
        let filename = 'StartupTN_Scoring_' + currentDate + '.xlsx';
        // Save the file
        FileSaver.saveAs(data, filename);
      });
  }
  /**
   * Calls the publish score API.
   */
  publishApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi.method(this.publishScore, '', 'get').subscribe((data: any) => {
      this.getdata.amizhthLoader('hide');
      if (data.responseStatus === 'Success') {
        /**
         * If the API call is successful, show a success notification.
         */
        this.notify.notifysuccess(data.responseMessage);
      } else {
        /**
         * If the API call is not successful, show an error notification.
         */
        this.notify.notifyError(data.responseMessage);
      }
    });
  }
  data = 'Yes';
  /**
   * Scrolls to the bottom of the mat-sidenav-content element.
   */
  scrollTo() {
    // Get the mat-sidenav-content element and scroll to the bottom
    document.getElementsByTagName('mat-sidenav-content')[0].scrollTo(0, 100000);
  }
  /**
   * Scrolls to the TNIMM section.
   */
  tnimmScroll() {
    // Scroll to the TNIMM section
    document.getElementsByTagName('mat-sidenav-content')[0].scrollTo(0, 400);
  }
  /**
   * Scrolls to the Maturity section.
   */
  maturityScroll() {
    // Scroll to the Maturity section
    document.getElementsByTagName('mat-sidenav-content')[0].scrollTo(0, 570);
  }
  /**
   * Scrolls to the Assessment section.
   */
  assesmentScroll() {
    // Scroll to the Assessment section
    document.getElementsByTagName('mat-sidenav-content')[0].scrollTo(0, 1100);
  }
  /**
   * Scrolls to the Scaleup section.
   */
  scaleupScroll() {
    // Scroll to the Scaleup section
    document.getElementsByTagName('mat-sidenav-content')[0].scrollTo(0, 1720);
  }
  /**
   * Scrolls to the Hustle section.
   */
  hustleScroll() {
    // Scroll to the Hustle section
    document.getElementsByTagName('mat-sidenav-content')[0].scrollTo(0, 2350);
  }
  /**
   * Scrolls to the Helpdesk section.
   */
  helpdeskScroll() {
    // Scroll to the Helpdesk section
    document.getElementsByTagName('mat-sidenav-content')[0].scrollTo(0, 2950);
  }
  /**
   * Scrolls to the Podcast section.
   */
  podcastScroll() {
    // Scroll to the Podcast section
    document.getElementsByTagName('mat-sidenav-content')[0].scrollTo(0, 3850);
  }

  /**
   * Scrolls to the Incubators Summit section.
   */
  summitScroll() {
    // Scroll to the Incubators Summit section
    document.getElementsByTagName('mat-sidenav-content')[0].scrollTo(0, 4550);
  }

  /**
   * Opens the Startup TN website in a new tab.
   */
  Startupweb() {
    // Open the Startup TN website in a new tab
    window.open('https://startuptn.in/', '_blank');
  }
  /**
   * Opens the Open Innovation page in a new tab.
   */
  openinovationpage() {
    // Open the Open Innovation page in a new tab
    window.open('http://openinnovation.startuptn.in/#', '_blank');
  }
  /**
   * Passes the initiative item to the service for processing.
   * @param item - The initiative item to be processed.
   */
  viewInitiative2(item: any) {
    // Call the service method with the provided item
    this.getdata.initiativeId2(item);
  }

  /**
   * Shows the edit modal if the application id is not 0.
   */
  showPopup() {
    if (this.applicationId === '0') {
      // Show the edit modal
      document.getElementById('editModal').style.display = 'block';
    }
  }
  /**
   * Hides the edit modal by setting its display property to 'none'.
   */
  closeModal(): void {
    // Hide the edit modal
    document.getElementById('editModal').style.display = 'none';
  }
}
